export const PREVIEW_DIMENSIONS = {
  WIDTH: 134,
  HEIGHT: 185,
};
